import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Loader, Modal } from "rsuite";
import { FiEye } from 'react-icons/fi';
import { ApiInvoice } from "../core/apis/invoice";
import { ActionsModal } from "../core/redux/slices/sliceModal";
import { EnumModals } from "../libs";
import { ModalData } from "./modal";
import { ConverterUtils } from "../utils";

export const InvoiceModal = ({
  showIconWithText,
  invoiceId,
  resetKey,
  invoiceStartDate,
  invoiceEndDate,
  yearMonth,
  pageTitle,
}: {
  showIconWithText?: boolean;
  invoiceId: string;
  resetKey: string;
  invoiceStartDate: string;
  invoiceEndDate: string;
  yearMonth?: string;
  pageTitle?: "caregiver-finance" | "patient-finance";
}) => {
  const [open, setOpen] = useState(false);
  const [previewDataUrl, setPreviewDataUrl] = useState("");
  const [isBusy, setIsBusy] = useState(false);
  const [invoiceYearMonth, setInvoiceYearMonth] = useState<Date>();
  const dispatch = useDispatch();
  const handleOpen = () => {
    if (yearMonth) {
      setOpen(true);
    } else {
      ModalData.InvoiceDownloadModal.startDate = invoiceStartDate;
      ModalData.InvoiceDownloadModal.endDate = invoiceEndDate;
      ModalData.InvoiceDownloadModal.OkButtonText = "Done";
      ModalData.InvoiceDownloadModal.handleDownload = (
        selectedYearMonth: Date
      ) => {
        setInvoiceYearMonth(selectedYearMonth);
        setOpen(true);
        dispatch(ActionsModal.hideModal(EnumModals.INVOICE_DOWNLOAD_MODAL));
      };

      dispatch(ActionsModal.openModal(EnumModals.INVOICE_DOWNLOAD_MODAL));
    }
  };
  const handleClose = () => {
    setOpen(false);
    setPreviewDataUrl("");
  };
  useEffect(() => {
    if (open) {
      setIsBusy(true);
      const selectedYearMonth = yearMonth || invoiceYearMonth?.toISOString();
      const isPatientReport = (() => {
        if (pageTitle) {
          return pageTitle === "patient-finance" ? true : false;
        } else {
          return undefined;
        }
      })();
      ApiInvoice.DownloadExcelPreview(
        invoiceId,
        "",
        selectedYearMonth,
        isPatientReport
      ).then((response) => {
        if (response !== null) {
          ConverterUtils.base64Converter(response!).then((base64String) => {
            setIsBusy(false);
            setPreviewDataUrl(base64String);
          });
        }
      });
    }
  }, [open, invoiceId, invoiceYearMonth, pageTitle, yearMonth]);

  return (
    <>
      {showIconWithText ? (
        <Button appearance="ghost" onClick={handleOpen}>
          <FiEye className="me-2" title="View Invoice" size={20} />
          View Invoice
        </Button>
      ) : (
        <button
          className="btn btn-sm btn-outline-primary"
          title="View Invoice"
          onClick={handleOpen}
        >
          <FiEye size={16} />
        </button>
      )}

      <Modal open={open} onClose={handleClose} key={resetKey} size="lg">
        <Modal.Header>
          <Modal.Title>Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="border-top text-center">
            {isBusy && !previewDataUrl && (
              <div className="text-center pt-5">
                <Loader className="text-center" size="md" />
              </div>
            )}

            {!!previewDataUrl && (
              <iframe
                title="invoice"
                src={`data:application/pdf;base64, ` + previewDataUrl}
                height={window.innerHeight * 0.9}
                width={450}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} type="reset" appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
